export class EarningPotentialModel {
    public id: any;
    public comm_plan_id: number;
    public effective_date: Date;
    public key_id: string;
    public key_value: string;
    public created_by: string;
    public created_dt: Date;
    public updated_by: string;
    public update_dt: Date;

    constructor() {
        this.id = null;
        this.comm_plan_id = null;
        this.effective_date = null;
        this.key_id = null;
        this.key_value = null;
        this.created_by = null;
        this.created_dt = null;
        this.update_dt = null;
        this.updated_by = null;
    }
}
